import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ModalContext } from 'stream-chat-angular';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { ChatModalDialogComponent } from './components/chat-modal-dialog/chat-modal-dialog.component';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrl: './chat-modal.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ChatModalComponent implements OnChanges {
  @Output() readonly isOpenChange = new EventEmitter<boolean>();
  @Input() isOpen: ModalContext['isOpen'] = false;
  @Input() content?: ModalContext['content'];

  readonly config: Partial<MatDialogConfig> = {
    maxWidth: '100vw',
    minWidth: '100vw',
    maxHeight: '100dvh',
    minHeight: '100dvh',
  };

  private readonly dialog = inject(MatDialog);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'].currentValue) {
      const dialogRef = this.dialog.open(ChatModalDialogComponent, {
        ...this.config,
        data: this.content,
      });

      dialogRef.afterClosed().subscribe(() => {
        this.isOpenChange.emit(false);
      });
    }
  }
}
